import React from "react";
import ReadOnlyField from "../compare-table/read-only-field";

const nameBuilder = (data) => {
    return <div>{data.name}</div>;
};

const AttributeRow = ({ id, data, width }) => {
    const td = data.map((column, index) => {
        const value = index === 0 ? nameBuilder(column, id) : <ReadOnlyField column={column} id={id} />;

        return <div key={`${id}_${index}`}>{value}</div>;
    });

    return (
        <div className="product-compare-row" style={width}>
            {td}
        </div>
    );
};

export default AttributeRow;
